exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#app,body,html{height:100%;margin:0;padding:0}.el-breadcrumb{margin-bottom:15px;font-size:12px}.el-card{box-shadow:0 1px 1px rgba(0,0,0,.15)!important}.el-table{font-size:12px}.el-pagination,.el-table{margin-top:15px}.fade-enter,.fade-leave-active{opacity:0}.fade-enter-active,.fade-leave-active{transition:opacity .5s}::-webkit-scrollbar{width:10px;height:10px}::-webkit-scrollbar-thumb{background-color:#857d7d;border-radius:5px}.el-aside::-webkit-scrollbar{width:10px;height:10px}.el-aside::-webkit-scrollbar-thumb{background-color:hsla(0,0%,100%,.2);border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/assets/css/global.css
// module id = 184
// module chunks = 1